type Severity = 'success' | 'warning' | 'danger' | 'info' | 'secondary'

const SEVERITY_BY_STATUS: Record<string, Severity> = {
  PENDING: 'info',
  ORIGINATING: 'warning',
  COMPLETED: 'success',
  NO_ANSWER: 'secondary',
  FAILED: 'danger',
  CANCELLED: 'secondary',
}

export function callbackStatusSeverity(status: string): Severity {
  return SEVERITY_BY_STATUS[status] ?? 'info'
}
